<template>
  <div class="c-side-m-nav">
    <ul class="c-side-nav-m-list">
      <h3 class="c-side-nav-m-list-title">账号管理</h3>
      <li>
        <router-link :to="{name: 'Profile'}">
          <div class="c-side-atems">
              <img src="../../assets/main/account-management@2x.png">个人信息
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">

          </div>
        </router-link>
      </li>
      <li>
          <router-link :to="{name: 'Organization'}">
            <div class="c-side-atems">
                <img src="../../assets/main/list_icon@2x.png">机构管理
                <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
            </div>
          </router-link>
      </li>
      <li>
        <router-link :to="{name: 'PasswordChange'}">
          <div class="c-side-atems">
              <img src="../../assets/main/mima@2x.png">密码修改
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'Specialist'}">
          <div class="c-side-atems">
              <img src="../../assets/bizmanager/list_icon@2x.png">专家管理
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
      <h3 class="c-side-nav-m-list-title">业务管理</h3>
      <li>
        <router-link :to="{name: 'PublishProject'}">
          <div class="c-side-atems">
              <img src="../../assets/bizmanager/list_icon-1@2x.png">已发布项目
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'SourceMatch'}">
          <div class="c-side-atems">
              <img src="../../assets/bizmanager/list_icon-2@2x.png">已报名项目
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'EngageSpecialist'}">
          <div class="c-side-atems">
              <img src="../../assets/bizmanager/list_icon-3@2x.png">聘专家
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'PolicyAdvisory'}">
          <div class="c-side-atems">
              <img src="../../assets/bizmanager/list_icon-4@2x.png">政策咨询
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'CreateStandard'}">
          <div class="c-side-atems">
              <img src="../../assets/bizmanager/list_icon-5@2x.png">创标准
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
      <!-- <li>
        <router-link :to="{name: 'MyVideo'}">
          <div class="c-side-atems">
              <img src="../../assets/bizmanager/list_icon-5@2x.png">我的视频
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li> -->
      <li>
        <router-link :to="{name: 'MutualEvaluation'}">
          <div class="c-side-atems">
              <img src="../../assets/bizmanager/list_icon-6@2x.png">评价
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
      <h3 class="c-side-nav-m-list-title">消息中心</h3>
      <li>
        <router-link :to="{name: 'MessageCenter'}">
          <div class="c-side-atems">
              <img src="../../assets/main/xiaoxizhongxin@2x.png">全部消息
              <img class="arrow-icon" src="../../assets/main/arrow-icon.png">
          </div>
        </router-link>
      </li>
    </ul>
    <!-- <div class="persona-banner"> -->
       <!--<img src="../../assets/main/persona-banner.png">
      <div class="headbox">
          <img src="../../assets/main/head.png">
          <p>智慧城市云</p>
      </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
    name: 'MobileNav',
    props: {
        msg: String,
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
.c-side-nav-m-list .c-side-atems img.arrow-icon{
  float: right;
  width: .25rem;
  margin: .5rem .2rem 0;
}
.c-side-m-nav{
  display:none;
  background:#F9F9F9;
  height:100%;
  padding-bottom:800px;
  margin-bottom:-800px;
}
.c-side-nav-m-list{
  width:90%;
  margin:.25rem auto;
  background:#fff;
  border-radius:.2rem;
}
.c-side-nav-m-list-title {
    padding-left: .3rem;
    box-sizing: border-box;
    font-size: .36rem;
    color: #333;
    padding-top: .28rem;
    padding-bottom: .16rem;
    border-bottom: solid 2px #F0F0F0;
}
.c-side-nav-m-list li{
  padding-left:.3rem;
  box-sizing:border-box;
}
.c-side-nav-m-list .c-side-atems{
  font-size:.32rem;
  line-height:1.2rem;
}
.c-side-nav-m-list .c-side-atems img{
  width:.34rem;
  margin-right:.2rem;
}
.persona-banner{
  position:relative;
  height: 3rem;
}
.persona-banner img{
  width:100%;
}
.headbox{
  position:absolute;
  top:.7rem;
  left:.5rem;
}
.headbox img{
  width:1.2rem;
  height:1.2rem;
  border-radius:100%;
  float:left;
}
.headbox p{
  float:left;
  color:#fff;
  font-size:.4rem;
  margin-left:.3rem;
  line-height:1.2rem;
}
@media screen and (max-width: 850px){
  .c-side-m-nav{display:block;}
}
</style>
